export default function AboutHero() {
  return (
    <section className="bg-[#2C2C2C] pt-52 pb-24">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          About Deer Point Contracting
        </h1>
        <p className="text-2xl md:text-3xl text-[#C5A55A] font-light">
          Full-Service Construction. Trusted Results.
        </p>
      </div>
    </section>
  );
}
